export const colorArray = [
  '#fff874',
  '#FFCA28',
  '#FFA726',
  '#FF7043',
  '#ef5350',
  '#EC407A',
  '#AB47BC',
  '#7E57C2',
  '#5C6BC0',
  '#1E85B3',
  '#26C6DA',
  '#26A69A',
  '#3d8e83',
  '#4a9c4e',
  '#6ac455',
  '#25cb0a',
  '#025004',
  '#3d5026',
  '#5A4640',
  '#8D6E63',
  '#917D87',
  '#78909C',
  '#586972',
  '#3E4B51',
  '#2C3539',
  '#C1CCD2',
]

export const otherColorArray = [
  '#CC6666',
  '#FF2200',
  '#B2502D',
  '#FF8800',
  '#593C00',
  '#CCAA66',
  '#BFB300',
  '#665F00',
  '#EEF2B6',
  '#7D8060',
  '#3F4030',
  '#CCFF00',
  '#144D00',
  '#74CC66',
  '#40FF40',
  '#397360',
  '#00FFCC',
  '#004033',
  '#79F2EA',
  '#698A8C',
  '#00CCFF',
  '#005C73',
  '#001B33',
  '#3D9DF2',
  '#434F59',
  '#265499',
  '#B6CEF2',
  '#0000BF',
  '#7979F2',
  '#0A004D',
  '#3B264D',
  '#AA00FF',
  '#AF8FBF',
  '#C36CD9',
  '#770080',
  '#330022',
  '#FF40A6',
  '#994D6B',
  '#F20041',
  '#F2B6C6',
  '#4C131B',
  '#594346',
]

let cache = {}

export default function stringToColor(text = '') {
  if (cache[text]) return cache[text]

  let number = 0

  for (let i = 0; i < text.length; i++) {
    number += text.charCodeAt(i)
  }

  let color = colorArray[number % colorArray.length]

  cache[text] = color

  return color
}

export function randomColor(text) {
  if (cache[text]) return cache[text]

  let color = colorArray[Math.floor(Math.random() * colorArray.length)]

  cache[text] = color

  return color
}
